var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"px-5 py-2 gap-2 uppercase rounded-md text-black text-opacity-70 text-xs font-medium",class:{'cursor-not-allowed opacity-50': _vm.disabled},staticStyle:{"background-color":"#EFB207"},attrs:{"disabled":_vm.disabled}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }